import { render } from "./MaoFullDataLoader.vue?vue&type=template&id=134cc61d&scoped=true"
import script from "./MaoFullDataLoader.vue?vue&type=script&lang=js"
export * from "./MaoFullDataLoader.vue?vue&type=script&lang=js"

import "./MaoFullDataLoader.vue?vue&type=style&index=0&id=134cc61d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134cc61d"]])

export default __exports__